import { ThemeConfig } from 'antd/es/config-provider/context';
import theme from './theme';

const antTheme: ThemeConfig = {
  token: {
    colorPrimary: theme.palette.primary[0],
    colorText: '#202020',
    fontFamily:
      "'Inter', sans-serif, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
  },
  components: {
    Button: {
      colorPrimaryHover: theme.palette.hover[0],
    },
  },
};

export default antTheme;
